// src/com/veh_info/VehInfoGql.js
import { gql } from "@apollo/client";
import { AppWord } from "../../value/AppConst";

/* ************************************************
 * VEH_INFO Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-10-04 16:25:57 using DbdbTap
 ************************************************ */

const VEH_INFO_LIST_PART = gql`
fragment VehInfoListPart on VehInfo {
    vehInfoSeq
    comId
    vehId
    vehPlates
    vehAlias
    rentYn
    termId
    vehTypeName
    vehTonName
    driverName
    driverMobile
    termPowerCd
    doorSensors
    operFontColor
    operBackColor
    noOperFontColor
    noOperBackColor
    emerFontColor
    emerBackColor
    offFontColor
    offBackColor
    syncTime
    regDate
    regUser
    transPosYn
    comName
    dcCd
    dcName
    gpsTime
    posSys
    lat
    lon
    speed
    location
    direction
}
`;
/*
extend type Query {
	vehInfoList(rentYn: String): [VehInfo]!
	vehInfoListOfDc(dcCd: String!): [VehInfo]!
    vehInfoListOfCompany(comId: String!): [VehInfo]!
    vehInfoListToBan(comId: String): [VehInfo]!
	vehInfoItem(vehInfoSeq:Int!): VehInfo
}
*/
export const LIST_VEH_INFO = gql`
${VEH_INFO_LIST_PART}
query ListVehInfo($rentYn:String) {
    vehInfoList(rentYn:$rentYn) {
        ...VehInfoListPart
    }
}
`;

export const LIST_VEH_INFO_OF_DC = gql`
${VEH_INFO_LIST_PART}
query ListVehInfoOfDc($dcCd:String!, $rentYn:String) {
    vehInfoListOfDc(dcCd:$dcCd, rentYn:$rentYn) {
        ...VehInfoListPart
    }
}
`;

export function devideVehiclesByCompany(records, sorter) {
    const map = {};
    records.forEach((rec) => {
        const comId = rec.comId;
        if(!map[comId]) map[comId] = [];
        map[comId].push(rec);
    });

    for(const comId of Object.keys(map)) {
        if(sorter) map[comId].sort(sorter);
        map[comId].unshift({vehPlates:AppWord.ChooseKorean, vehInfoSeq:0, comId:comId});
    }
    return map;
}

export const LIST_VEH_INFO_OF_COMPANY = gql`
${VEH_INFO_LIST_PART}
query ListVehInfoOfCompany($comId:String!, $rentYn:String) {
    vehInfoListOfCompany(comId:$comId, rentYn:$rentYn) {
        ...VehInfoListPart
    }
}
`;

/*
    세션의 DC값을 사용해서 LIST_VEH_INFO_OF_DC와 같은 결과를 리턴한다.
    vehInfoListOfSessionDcRent: [VehInfo]!
*/
export const LIST_VEH_INFO_OF_SESSION_DC_RENT = gql`
${VEH_INFO_LIST_PART}
query ListVehInfoOfSessionDcRent {
    vehInfoListOfSessionDcRent {
        ...VehInfoListPart
    }
}
`;

export const LIST_VEH_INFO_TO_BAN = gql`
query ListVehInfoToBan($comId:String) {
    vehInfoListToBan(comId:$comId) {
        vehInfoSeq
        comId
        vehId
        vehPlates
        comName
        dcCd
        dcName
    }
}
`;

export const GET_VEH_INFO = gql`
${VEH_INFO_LIST_PART}
query GetVehInfo($vehInfoSeq:Int!) {
    vehInfoItem(vehInfoSeq:$vehInfoSeq) {
        ...VehInfoListPart
    }
}
`;

// vehInfoItemByPlates(vehPlates: String!): VehInfo
export const GET_VEH_INFO_BY_PLATES = gql`
${VEH_INFO_LIST_PART}
query GetVehInfoByPlates($vehPlates:String!) {
    vehInfoItemByPlates(vehPlates:$vehPlates) {
        ...VehInfoListPart
    }
}
`;


export const SET_VEH_INFO_TRANS_POS_YN = gql`
${VEH_INFO_LIST_PART}
mutation SetVehInfoTransPosYn($vehInfo:InputVehInfoSetTransPosYn!) {
    vehInfoSetTransPosYn(vehInfo:$vehInfo) {
        ok
        message
        list {
            ...VehInfoListPart
        }
    }
}
`;

export const SET_VEH_INFO_MULTIPLE_TRANS_POS_YN = gql`
${VEH_INFO_LIST_PART}
mutation SetVehInfoMultipleTransPosYn($vehInfo:InputVehInfoSetMultipleTransPosYn!) {
    vehInfoSetMultipleTransPosYn(vehInfo:$vehInfo) {
        ok
        message
        list {
            ...VehInfoListPart
        }
    }
}
`;

/*

input InputVehInfoAddRental {
	vehPlates: String
	vehTypeName: String
	vehTonName: String
	driverName: String
	driverMobile: String
}

input InputVehInfoEditRental {
	vehInfoSeq: Int!
	vehPlates: String
	vehTypeName: String
	vehTonName: String
	driverName: String
	driverMobile: String
}

input InputVehInfoRemove {
	vehInfoSeq: Int!
}

    
    vehInfoAddRental(vehInfo: InputVehInfoAddRental!): CommonResponse!
    vehInfoEditRental(vehInfo: InputVehInfoEditRental!): CommonResponse!
    vehInfoRemoveRental(vehInfo: InputVehInfoRemove!): CommonResponse!

*/

export const ADD_VEH_INFO_RENTAL = gql`
mutation AddVehInfoRental($vehInfo:InputVehInfoAddRental!) {
    vehInfoAddRental(vehInfo:$vehInfo) {
        ok
        message
    }
}
`;

export const EDIT_VEH_INFO_RENTAL = gql`
mutation EditVehInfoRental($vehInfo:InputVehInfoEditRental!) {
    vehInfoEditRental(vehInfo:$vehInfo) {
        ok
        message
    }
}
`;

export const REMOVE_VEH_INFO_RENTAL = gql`
mutation RemoveVehInfoRental($vehInfo:InputVehInfoRemove!) {
    vehInfoRemoveRental(vehInfo:$vehInfo) {
        ok
        message
    }
}
`;



